(function() {

  var LIST_ID = "Wpm7ku";
  var API_KEY = "TiFTEa";

  // Leer email desde URL param (?email=xxx)
  var urlParams  = new URLSearchParams(window.location.search);
  var emailParam = urlParams.get('email') || '';

  var COMUNAS = window.NAIRE_COMUNAS || {};

  var LISTA = Object.keys(COMUNAS).sort();
  var selectedComuna = null;

  // Normalizacion: sin tildes, sin mayusculas, sin espacios de sobra.
  // Es lo que permite que "nunoa" y "NUNOA " resuelvan a la comuna real.
  // Mapeo explicito de los unicos caracteres acentuados que existen en la
  // lista de comunas. Sin rangos Unicode: mas facil de auditar y de probar.
  var ACENTOS = { 'á':'a','à':'a','ä':'a','â':'a',
                  'é':'e','è':'e','ë':'e','ê':'e',
                  'í':'i','ì':'i','ï':'i','î':'i',
                  'ó':'o','ò':'o','ö':'o','ô':'o',
                  'ú':'u','ù':'u','ü':'u','û':'u',
                  'ñ':'n' };

  function normalize(s) {
    var t = (s == null ? '' : String(s)).trim().toLowerCase();
    var out = '';
    for (var i = 0; i < t.length; i++) {
      var ch = t.charAt(i);
      out += (ACENTOS[ch] !== undefined ? ACENTOS[ch] : ch);
    }
    return out.replace(/\s+/g, ' ');
  }

  var NORM = {};
  LISTA.forEach(function(c) { NORM[normalize(c)] = c; });
  var NORM_KEYS = Object.keys(NORM);

  // Resuelve lo que el usuario escribio, aunque no haya tocado el dropdown.
  function resolveComuna() {
    if (selectedComuna && COMUNAS[selectedComuna]) return selectedComuna;

    var n = normalize(document.getElementById('ma-comuna').value);
    if (!n) return null;

    if (NORM[n]) return NORM[n];

    var pref = NORM_KEYS.filter(function(k) { return k.indexOf(n) === 0; });
    if (pref.length === 1) return NORM[pref[0]];

    var sub = NORM_KEYS.filter(function(k) { return k.indexOf(n) !== -1; });
    if (sub.length === 1) return NORM[sub[0]];

    return null;
  }

  // Dropdown
  function maShowDropdown() {
    renderDropdown(document.getElementById('ma-comuna').value);
  }

  function maFilterComunas(val) {
    selectedComuna = null;
    maClearError('comuna');
    renderDropdown(val);
  }

  function renderDropdown(val) {
    var dd = document.getElementById('maDropdown');
    var n  = normalize(val);
    var filtered = n
      ? LISTA.filter(function(c) { return normalize(c).indexOf(n) !== -1; })
      : LISTA;
    if (!filtered.length) { dd.style.display = 'none'; return; }
    dd.innerHTML = filtered.map(function(c) {
      return '<li onclick="maSelectComuna(\'' + c.replace(/'/g, "\\'") + '\')">' + c + '</li>';
    }).join('');
    dd.style.display = 'block';
  }

  function maSelectComuna(c) {
    selectedComuna = c;
    document.getElementById('ma-comuna').value = c;
    document.getElementById('maDropdown').style.display = 'none';
    maClearError('comuna');
  }

  // Enter envia, sin obligar a tocar la sugerencia
  function maKeydown(e) {
    if (e.key === 'Enter') { e.preventDefault(); maSubmit(); }
  }

  document.addEventListener('click', function(e) {
    var input = document.getElementById('ma-comuna');
    var dd = document.getElementById('maDropdown');
    if (dd && input && !input.contains(e.target) && !dd.contains(e.target)) {
      dd.style.display = 'none';
    }
  });

  // Errores
  function maClearError(field) {
    var el = document.getElementById('ma-' + field + '-error');
    if (el) el.classList.remove('visible');
    var input = document.getElementById('ma-' + field);
    if (input) input.style.borderColor = '';
  }

  function showError(field, msg) {
    var el = document.getElementById('ma-' + field + '-error');
    if (el) { el.textContent = msg; el.classList.add('visible'); }
    var input = document.getElementById('ma-' + field);
    if (input) input.style.borderColor = '#EF5C22';
  }

  // Paso 1: mostrar el resultado. Sin pedir nada a cambio.
  function maSubmit() {
    var comuna = resolveComuna();
    if (!comuna) {
      showError('comuna', 'No encontramos esa comuna. Revísala o elígela de la lista.');
      return;
    }
    selectedComuna = comuna;
    document.getElementById('ma-comuna').value = comuna;
    document.getElementById('maDropdown').style.display = 'none';
    maClearError('comuna');

    showSuccess(comuna);

    // Si el email ya venia en la URL (flujo de reactivacion), no se vuelve a
    // pedir: se registra en silencio y se confirma.
    if (emailParam) {
      document.getElementById('maInformeWrap').style.display = 'none';
      document.getElementById('maInformeOk').style.display = 'block';
      enviarAKlaviyo(emailParam, comuna);
    }
  }

  // Paso 2: el informe completo, ya como oferta
  function maEnviarInforme() {
    var email = document.getElementById('ma-email').value.trim();
    if (!email) {
      showError('email', 'Ingresa tu email para recibir el informe.');
      return;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError('email', 'Email no válido.');
      return;
    }

    var btn = document.getElementById('maInformeBtn');
    btn.disabled = true;
    btn.textContent = 'Enviando...';

    enviarAKlaviyo(email, selectedComuna, function() {
      document.getElementById('maInformeWrap').style.display = 'none';
      document.getElementById('maInformeOk').style.display = 'block';
    });
  }

  function enviarAKlaviyo(email, comuna, done) {
    var data = COMUNAS[comuna] || {};

    var payload = {
      data: {
        type: "subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                properties: {
                  comuna: comuna,
                  dureza_agua: data.dureza || null,
                  nivel_dureza_agua: data.nivel || null,
                  diagnostico_fuente: emailParam ? "email-reactivacion" : "pagina-mi-agua"
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: "list", id: LIST_ID } }
        }
      }
    };

    fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + API_KEY, {
      method: "POST",
      headers: { "Content-Type": "application/json", "revision": "2024-02-15" },
      body: JSON.stringify(payload)
    })
    .then(function() { if (done) done(); })
    .catch(function(err) {
      console.error('Klaviyo error:', err);
      if (done) done();
    });
  }

  // Resultado. Mismos cortes y colores que la escala OMS de la vista anterior,
  // para que el resultado se lea contra la referencia que la persona ya vio.
  var NIVELES = {
    "Blanda":    { color: "#2E7D52", lectura: "Carga mineral baja. Aun así, el cloro de la red sigue presente en la ducha." },
    "Moderada":  { color: "#1845A8", lectura: "Impacto leve, pero constante: son minerales y cloro sobre tu piel todos los días." },
    "Dura":      { color: "#C94E1C", lectura: "A este nivel los minerales bloquean la absorción de lo que aplicas después." },
    "Muy dura":  { color: "#EF5C22", lectura: "Impacto significativo. Tus productos llegan sobre piel que el agua ya resecó." }
  };

  function showSuccess(comuna) {
    var data  = COMUNAS[comuna] || {};
    var nivel = data.nivel || "";
    var info  = NIVELES[nivel] || { color: "#9A9490", lectura: "" };

    document.getElementById('maSuccessComuna').textContent = comuna;

    // Si por lo que sea no hay cifra, se oculta la tarjeta y el puente igual queda.
    var dureza = document.getElementById('maResDureza');
    if (data.dureza != null) {
      dureza.textContent = data.dureza;
    } else {
      dureza.closest('.miagua-resultado-cifra').style.display = 'none';
    }

    document.getElementById('maResNivel').textContent = nivel;
    document.getElementById('maResNivelWrap').style.color = info.color;
    document.getElementById('maResDot').style.background  = info.color;
    document.getElementById('maResLectura').textContent   = info.lectura;

    document.getElementById('miaguaFormView').style.display = 'none';
    document.getElementById('miaguaSuccessView').classList.add('visible');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Expuestas para los handlers inline del markup
  window.maShowDropdown = maShowDropdown;
  window.maFilterComunas = maFilterComunas;
  window.maSelectComuna = maSelectComuna;
  window.maKeydown = maKeydown;
  window.maClearError = maClearError;
  window.maSubmit = maSubmit;
  window.maEnviarInforme = maEnviarInforme;

})();
